import React, { useState } from 'react';
import './styles/layout.css';
import logo from './assets/logo.png';
import AnimatedButton from './components/AnimatedButton';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import Faqs from './components/faqs';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';


const WebsiteLayout = ({ children }) => {
  const location = useLocation();
   const navigate = useNavigate(); 
  const [activeLink, setActiveLink] = useState(location.pathname);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLinkClick = (link) => {
    setActiveLink(link);
    setIsMenuOpen(false); // Close menu when clicking a link
    navigate(link);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="layout">
      <nav className="navbar">
        <div className="navbar-logo">
          <img src={logo} width="120rem" alt="Logo"  onClick={()=>handleLinkClick('/')} style={{cursor:'pointer'}}/>
        </div>
        <div className={`navbar-menu ${isMenuOpen ? 'open' : ''}`}>
          <ul>
            <li>
              <a
                href="/Robotics-Home"
                className={activeLink === '/Robotics-Home' ? 'active' : ''}
                onClick={() => handleLinkClick('/Robotics-Home')}
              >
                Home
              </a>
            </li>
            <li>
              <a
                href="/Robotics-AboutUs"
                className={activeLink === '/Robotics-AboutUs' ? 'active' : ''}
                onClick={() => handleLinkClick('/Robotics-AboutUs')}
              >
                About Us
              </a>
            </li>
            <li>
              <a
                href="/Robotics-Services"
                className={activeLink === '/Robotics-Services' ? 'active' : ''}
                onClick={() => handleLinkClick('/Robotics-Services')}
              >
                Services
              </a>
            </li>
            <li>
              <a
                href="/Robotics-Products"
                className={activeLink === '/Robotics-Products' ? 'active' : ''}
                onClick={() => handleLinkClick('/Robotics-Products')}
              >
                Products
              </a>
            </li>
            <li>
              <a
                href="/Robotics-Team"
                className={activeLink === '/Robotics-Team' ? 'active' : ''}
                onClick={() => handleLinkClick('/Robotics-Team')}
              >
                Team
              </a>
            </li>
            <li>
              <a
                href="/Robotics-Usecase"
                className={activeLink === '/Robotics-Usecase' ? 'active' : ''}
                onClick={() => handleLinkClick('/Robotics-Usecase')}
              >
                Use Cases
              </a>
            </li>
          </ul>
          <a onClick={() => handleLinkClick('/Robotics-Contact')}><AnimatedButton text="Contact Us" link="" /></a>
        </div>
        <div className="hamburger" onClick={toggleMenu}>
          <div />
          <div />
          <div />
        </div>
      </nav>


      <main className="content">
      { children }
        <Faqs/>
      </main>


      <footer className="footer">
      <div className="footer-top">
        <div className="footer-logo">
          <img src={logo} alt="Logo" width="120" onClick={()=>handleLinkClick('/')} style={{cursor:'pointer'}}/>
        </div>
        <div className="footer-menu">
          <ul>
            <li><a href="/Robotics-Home"  onClick={() => handleLinkClick('/Robotics-Home')}>Home</a></li>
            <li><a href="/Robotics-AboutUs" onClick={() => handleLinkClick('/Robotics-AboutUs')}>About Us</a></li>
            <li><a href="/Robotics-Services" onClick={() => handleLinkClick('/Robotics-Services')}>Services</a></li>
            <li><a href="/Robotics-Products" onClick={() => handleLinkClick('/Robotics-Products')}>Products</a></li>
            <li><a href="/Robotics-Team" onClick={() => handleLinkClick('/Robotics-Team')}>Teams</a></li>
            <li><a href="/Robotics-Contact" onClick={() => handleLinkClick('/Robotics-Contact')}>Contact Us</a></li>
          </ul>
        </div>
      </div>
      <div className="footer-middle">
        <div className="subscribe-section">
          <h3>Subscribe</h3>
          <p>Stay up to date with our latest news and articles.</p>
          <div className="subscribe-form">
            <input type="email" placeholder="Enter your email" />
            <button>Submit</button>
          </div>
        </div>
        <div className="social-links">
          <h4>FOLLOW US:</h4>
          <div className="icons">
            <a href="https://www.linkedin.com/company/companysix/" aria-label="Facebook"><FaFacebookF /></a>
            <a href="https://www.linkedin.com/company/companysix/" aria-label="Instagram"><FaInstagram /></a>
            <a href="https://www.linkedin.com/company/companysix/" aria-label="LinkedIn"><FaLinkedinIn /></a>
            <a href="https://www.linkedin.com/company/companysix/" aria-label="Twitter"><FaTwitter /></a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© - CO6 Group, All rights are reserved.</p>
      </div>
    </footer>
    </div>
  );
};

export default WebsiteLayout;
